var React = require('react');

function PlanStarter (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M47.2549 17L86.5098 56.2549L47.2549 95.5098L8 56.2549L47.2549 17Z","fill":"black","key":0}),React.createElement("path",{"d":"M28.0454 56.2549L63.7647 20.5355L99.4841 56.2549L63.7647 91.9743L28.0454 56.2549Z","fill":"white","stroke":"black","strokeWidth":"5","key":1}),React.createElement("path",{"d":"M49.4881 55.5L64 40.585L78.5119 55.5L64 70.415L49.4881 55.5Z","fill":"black","stroke":"black","strokeWidth":"5","key":2})]);
}

PlanStarter.defaultProps = {"width":"112","height":"112","viewBox":"0 0 112 112","fill":"none"};

module.exports = PlanStarter;

PlanStarter.default = PlanStarter;
